// this is an autogenerated file from DesignSystem/DataVaxiomProfessionalView/Content/Phone/Phones/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_DataVaxiomProfessionalView_Content_Phone_Phones($person_id: numeric!) {
  vaxiom_contact_method_associations(
    where: {
      person_id: { _eq: $person_id }
      contact_method: { dtype: { _eq: "phone" } }
    }
    order_by: { id: asc }
  ) {
    id
    preference
    contact_method_id
    description
    phone {
      id
      type
      number
    }
  }
}

`